import { AuthorizedUser } from "../../../api/repositories/backend/models/auth";
import { SubscribeGlobalState } from "../../../common/hooks/global-state";
import { SubFooterButton } from "../functional/buttons";
import { PaymentImage, SizedImage } from "../ui/file-contents";

export const Footer: React.FC<{
    className?: string
}> = ({ className }) => {
    const authorized = SubscribeGlobalState("authorizedUser") as AuthorizedUser | undefined

    return (
        <footer className={`${className || ''} h-[120px] flex flex-row items-center lg:h-[288px] mt-[50px] lg:mt-[110px] bg-black w-full`}>
            <div className="w-[726px] lg:w-[1060px] 2xl:w-[1560px] items-center mx-auto flex flex-row gap-[20px] justify-between py-[20px] px-[20px] lg:py-[100px]">
                <div className="flex flex-col text-[8px] xl:min-w-[300px] text-gray-500 font-['Roboto']">
                    <div>ИНН 501812959580</div>
                    <div>Антонов Иван Сергеевич</div>
                    <div>Россия, Московская обл. г. Королев</div>
                    <div>Email: dota1x6help@ya.ru</div>
                </div>
                <SubFooterButton isAuthorized={authorized?.authorized} />
                <div className="hidden sm:flex flex-row gap-[6px] lg:gap-[13px] items-center">
                    <PaymentImage imgClassName="h-[30px] lg:h-[50px]" name="mastercard" />
                    <PaymentImage imgClassName="h-[30px] lg:h-[50px]" name="visa" />
                    <PaymentImage imgClassName="lg:w-[94px] h-[22px] lg:h-[30px]" name="mir" />
                    <PaymentImage imgClassName="h-[22px] lg:h-[30px]" name="jsb" />
                </div>
            </div>
        </footer>
    );
};
